/**
 * RecoveryTrac.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchOperator } from './searchOperator';
import { SearchFilterOperationOfTimeRecordSearchV3ResponseValue } from './searchFilterOperationOfTimeRecordSearchV3ResponseValue';


/**
 * Logical Leaf terminated operation of a <see cref=\"!:SearchFilter\" />  that handles a WHERE filter of the data, based on a   string SearchFilterOperation&lt;T&gt;.Key, SearchOperator SearchFilterOperation&lt;T&gt;.Operator, and compared object? SearchFilterOperation&lt;T&gt;.Value
 */
export interface SearchFilterOperationOfTimeRecordSearchV3Response { 
    /**
     * Field to filter on
     */
    key: SearchFilterOperationOfTimeRecordSearchV3Response.KeyEnum;
    /**
     * Operation to use for the filter function
     */
    operator: SearchOperator;
    value: SearchFilterOperationOfTimeRecordSearchV3ResponseValue | null;
}
export namespace SearchFilterOperationOfTimeRecordSearchV3Response {
    export const KeyEnum = {
        Activity: 'Activity',
        ActivityLogId: 'ActivityLogId',
        ActivityType: 'ActivityType',
        ApprovedBy: 'ApprovedBy',
        ApprovedDate: 'ApprovedDate',
        ApprovedTimeZoneId: 'ApprovedTimeZoneId',
        CapturedClockIn: 'CapturedClockIn',
        CapturedClockInTimeZoneId: 'CapturedClockInTimeZoneId',
        CapturedClockOut: 'CapturedClockOut',
        CapturedClockOutTimeZoneId: 'CapturedClockOutTimeZoneId',
        ClientRefId: 'ClientRefId',
        ClientRefName: 'ClientRefName',
        ClockIn: 'ClockIn',
        ClockInTimeZoneId: 'ClockInTimeZoneId',
        ClockOut: 'ClockOut',
        ClockOutTimeZoneId: 'ClockOutTimeZoneId',
        ClockStatus: 'ClockStatus',
        CreatedBy: 'CreatedBy',
        CreatedDate: 'CreatedDate',
        Date: 'Date',
        EmployeeId: 'EmployeeId',
        EmployeeNumber: 'EmployeeNumber',
        FirstName: 'FirstName',
        HasComments: 'HasComments',
        Hours: 'Hours',
        Id: 'Id',
        IsFlaggedForAudit: 'IsFlaggedForAudit',
        LaborCategoryId: 'LaborCategoryId',
        LaborCategoryName: 'LaborCategoryName',
        LaborCategoryNumber: 'LaborCategoryNumber',
        LastName: 'LastName',
        LockedBy: 'LockedBy',
        LockedDate: 'LockedDate',
        LockedTimeZoneId: 'LockedTimeZoneId',
        LockStatus: 'LockStatus',
        ModifiedBy: 'ModifiedBy',
        ModifiedDate: 'ModifiedDate',
        OrganizationId: 'OrganizationId',
        OrganizationName: 'OrganizationName',
        ProjectId: 'ProjectId',
        ProjectName: 'ProjectName',
        ProjectNumber: 'ProjectNumber',
        ReturnedBy: 'ReturnedBy',
        ReturnedDateOffset: 'ReturnedDateOffset',
        ReturnedTimeZoneId: 'ReturnedTimeZoneId',
        ReviewStatus: 'ReviewStatus',
        SpecialPayCode: 'SpecialPayCode',
        SubmittedTimeZoneId: 'SubmittedTimeZoneId',
        Tags: 'Tags',
        TaskId: 'TaskId',
        TaskName: 'TaskName',
        TaskNumber: 'TaskNumber',
        TimecardId: 'TimecardId',
        TypeId: 'TypeId',
        TypeName: 'TypeName',
        UserId: 'UserId',
        UserName: 'UserName',
        VerifiedBy: 'VerifiedBy',
        VerifiedDate: 'VerifiedDate',
        VerifiedTimeZoneId: 'VerifiedTimeZoneId'
    } as const;
    export type KeyEnum = typeof KeyEnum[keyof typeof KeyEnum];
}


